import { nullable, struct } from 'io-ts/Decoder';

import { ManualId } from '../../../../user/status/Id';

export const Request = struct({
	statusId: nullable(ManualId),
});
